import axios from 'axios'

const axiosSource = axios.CancelToken.source()



export default axiosSource